// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__BNbwG","boxSizing":"style_boxSizing__3WSJZ","buttonContainer":"style_buttonContainer__2ruGY","title":"style_title__3Zs5s"};